"use client";

import { useEffect } from "react";
import Image from "next/image";
import JourneyTimeline from "@/components/journey-timeline";
import Certifications from "@/components/certifications";
import TeamGrid from "@/components/team-grid";
import Careers from "@/components/careers";
import Footer from "@/components/footer";

function AboutHero() {
  return (
    <section className="w-full px-4 sm:px-5 lg:px-[5%] py-6 md:py-14">
      <div className="mx-auto max-w-[1200px]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-start">
          {/* ---- LEFT CONTENT ---- */}
          <div className="min-w-0">
            <span className="inline-flex px-4 py-2 rounded-[30px] border-2 border-black text-[12px] md:text-sm font-bold text-black">
              About Us
            </span>

            <h1 className="mt-4 md:mt-6 tracking-tight text-[#333] leading-tight text-[clamp(26px,4vw,44px)]">
              We are MMI – Manufacturing, Mastered.
            </h1>

            <p className="mt-4 text-[14px] sm:text-[15px] md:text-[16px] leading-[1.65] text-[#555]">
              MMI (Michigan Manufacturing International) was established in 1991
              as a manufacturing and supply-chain partner for global OEMs,
              focused on produced-to-print components and assemblies.
            </p>

            <p className="mt-4 text-[14px] sm:text-[15px] md:text-[16px] leading-[1.65] text-[#555]">
              MMI operates four specialized manufacturing plants in India,
              supported by local engineering, quality, and operations teams, and
              governed by certified quality systems including ISO 9001 and IATF
              16949. Supplier and production management includes qualification,
              audits, process validation, inspection, traceability, production
              tracking, inventory management, and logistics coordination,
              aligned to customer demand schedules and purchasing terms while
              managing supply-chain risk.
            </p>

            <p className="mt-4 text-[14px] sm:text-[15px] md:text-[16px] leading-[1.65] text-[#555]">
              With offices across six countries, MMI functions as a single
              operational interface between OEM engineering, procurement, and
              manufacturing teams, aligning design intent, production execution,
              and delivery requirements.
            </p>

            <p className="mt-4 font-medium text-[#555]">
              We’re Manufacturers. We’re Supply Chain Partners. We’re Engineers.
              We’re Innovators.
            </p>
          </div>

          {/* ---- RIGHT IMAGES ---- */}
          <div className="relative min-w-0 flex justify-center md:justify-end md:mt-16">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/2.png-fyRWHSWHUhJNCrWkR0docMpQ1smux9.jpeg"
              alt="Precision manufacturing process - welding and fabrication"
              className="w-full max-w-[400px] h-auto aspect-[3/4] rounded-[20px] object-cover shadow-[0_4px_12px_rgba(0,0,0,0.08)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default function AboutClient() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="w-full">
      <AboutHero />
      <div id="our-journey">
        <JourneyTimeline />
      </div>
      <div className="py-8">
        <Certifications />
      </div>
      <div className="py-8">
        <TeamGrid />
      </div>
      <div className="py-8">
        <Careers />
      </div>
      <Footer />
    </main>
  );
}
